export default "__VITE_ASSET__3290e638__"